import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import Login from './pages/Login';
import MailValidator from './pages/MailValidator';
import WaitEmailConfirmation from './pages/WaitEmailConfirmation';
import Donate from './pages/Donate';
import VoiceSettings from './pages/VoiceSettings';
import Words from './pages/Words';
import Cards from './pages/Cards';
import Topics from './pages/Topics';
import TermsOfService from './pages/TermsOfService';
import UsersAdmin from './pages/UsersAdmin';
import Study from './pages/Study';
import Progress from './pages/Progress';
import Course from './pages/Course';

import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="register" element={<Register />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route path="mail_validator" element={<MailValidator />} /> 
          <Route path="/wait-email-confirmation" element={<WaitEmailConfirmation />} />
          <Route path="donate" element={<Donate />} />
          <Route path="/voice-settings" element={<VoiceSettings />} />
          <Route path="/words" element={<Words />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/admin/users" element={<UsersAdmin />} />
          <Route path="/study" element={<Study />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/course" element={<Course />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
